<template>
  <div class="card-secondary-wrap">
    <div class="card-marketing" :style="`background: ${colorCard}`">
      <div class="card-frosted"></div>
      <div class="card-content">
        <div class="location-pill">
          <span v-if="country_flag">{{ country_flag }}</span>
          <span v-else class="pin">📍</span>
          {{ country_name }}
        </div>
        <p class="card-label">
          {{ textInfo === "influencers"
            ? `${$t(`creator.cardTitle.${textInfo}`)} @${getTextAfterAt(mention)}`
            : textInfo === 'best_quality' || textInfo === 'best_quality_2'
              ? `${$t(`creator.cardTitle.best_quality`)} ${country_name}`
              : $t(`creator.cardTitle.${textInfo}`) }}
        </p>
        <div class="card-bottom">
          <div class="avatars">
            <img
              v-for="(image, index) in images.slice(0, 5)"
              :key="`img-${index}`"
              :src="image"
              class="avatar-img"
              :style="{ zIndex: 5 - index, marginLeft: index === 0 ? '0' : '-9px' }"
            />
          </div>
          <div class="cta-btn">
            <span class="cta-text">{{ $t('creator.clickToConsult') }}</span>
            <span class="cta-arrow">→</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AnalyzerCardSecondary",
  props: {
    textInfo:     { type: String, default: '' },
    mention:      { type: String, default: '' },
    colorCard:    { type: String, default: '#039BE5' },
    images:       { type: Array,  default: () => [] },
    filters:      { type: Object, default: () => ({}) },
    country_name: { type: String, default: '' },
    country_flag: { type: String, default: '' },
  },
  methods: {
    getTextAfterAt(mention) {
      const idx = mention.indexOf('@');
      return idx !== -1 ? mention.substring(idx + 1) : '';
    }
  },
};
</script>

<style scoped>
.card-secondary-wrap { height: 100%; }

.card-marketing {
  min-height: 152px;
  border-radius: 18px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  transition: transform .22s ease, box-shadow .22s ease;
}
.card-marketing:hover {
  transform: translateY(-4px);
  box-shadow: 0 14px 36px rgba(0,0,0,.18);
}
.card-marketing:hover .cta-text { opacity: 1; transform: translateX(0); }
.card-marketing:hover .cta-arrow { transform: translateX(4px); }

/* frosted overlay */
.card-frosted {
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom, rgba(0,0,0,.08) 0%, rgba(0,0,0,.36) 100%);
  backdrop-filter: blur(1px);
  pointer-events: none;
}

.card-content {
  position: relative;
  z-index: 1;
  padding: 16px 18px 14px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* location pill */
.location-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: rgba(255,255,255,.18);
  border: 1px solid rgba(255,255,255,.32);
  color: white;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 9px;
  border-radius: 20px;
  width: fit-content;
  letter-spacing: .03em;
  backdrop-filter: blur(4px);
}
.pin { font-size: 11px; }

/* title */
.card-label {
  font-size: 15px;
  font-weight: 800;
  color: white;
  line-height: 1.28;
  margin: 0;
  text-shadow: 0 1px 5px rgba(0,0,0,.22);
  flex: 1;
}

/* bottom row */
.card-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4px;
}

.avatars {
  display: flex;
  align-items: center;
}
.avatar-img {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid rgba(255,255,255,.65);
  object-fit: cover;
  position: relative;
}

/* cta */
.cta-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  color: rgba(255,255,255,.95);
  font-size: 12px;
  font-weight: 700;
  background: rgba(255,255,255,.18);
  border: 1px solid rgba(255,255,255,.3);
  padding: 4px 10px;
  border-radius: 20px;
  backdrop-filter: blur(4px);
}
.cta-text {
  opacity: 1;
  transform: translateX(0);
  white-space: nowrap;
}
.cta-arrow {
  font-size: 15px;
  transition: transform .2s ease;
}
</style>
